import React from 'react';
import { getFacilityOnlineAuction } from 'actions';
import UserIpService from 'services/UserIpService';
import AuctionService from 'services/AuctionService';
import { Details } from 'components/Auctions/Details';
import { NextPage, NextPageContext } from 'next';

interface ReduxAction {
    type: string;
    payload?: unknown;
}

type ThunkAction = (dispatch: (action: ReduxAction) => void) => Promise<unknown>;

interface DetailsPageProps {
    auction_id: string;
    user_ip: string;
    handleShowOtherAuctions?: (show: boolean) => void;
    pageData?: Record<string, unknown>;
}

const DetailsPage: NextPage<DetailsPageProps> = ({ auction_id, user_ip, ...props }) => {
    return (
        <Details
            auctionId={auction_id}
            userIp={user_ip}
            handleShowOtherAuctions={props.handleShowOtherAuctions}
        />
    );
};

interface ExtendedNextPageContext extends NextPageContext {
    store: {
        dispatch: <T>(action: ReduxAction | ThunkAction) => Promise<T>;
    };
}

DetailsPage.getInitialProps = async ({ res, req, store, query }: ExtendedNextPageContext) => {
    const auctionId = query.auction_id as string;
    
    if (!auctionId || isNaN(parseInt(auctionId))) {
        if (res) {
            res.writeHead(302, {Location: '/auctions?err=no_auction_id'});
            res.end();
        }
        return { auction_id: '', user_ip: '', pageData: {} };
    }

    const userIp = await UserIpService.getUserIp(req);

    let auction;
    try {
        const auctionData = await AuctionService.getAuction(auctionId, true, userIp, true);
        auction = auctionData.auction;
    } catch (e) {
        console.error(e);
        if (res) {
            res.writeHead(301, { Location: '/auctions' });
            res.end();
        }
        return { auction_id: auctionId, user_ip: userIp, pageData: {} };
    }
    
    if (!auction) {
        return { auction_id: auctionId, user_ip: userIp, pageData: {} };
    }
    
    
    await store.dispatch<void>(getFacilityOnlineAuction(auction.facility_id));
    
    
    const pageData = {
        h1: `Storage Auction in ${auction.city}, ${auction.state}`,
        title: `Online Storage Auction in ${auction.city}, ${auction.state}`,
        description: `Bid online in a live storage auction in ${auction.city}, ${auction.state}. The current bid is ${auction.current_bid?.formatted} and ending soon. Check out what is being auctioned right now!`,
        marginBottom: 'pageTitle marginB20',
        og: {
            description: `Storagetreasures.com | Auction #${auctionId}`,
            image: auction.images?.length > 0 ? auction.images[0]?.image_path : '',
        },
    };

    return { auction_id: auctionId, user_ip: userIp, pageData, facility_id: auction.facility_id };
};

export default DetailsPage;